module.exports = __webpack_public_path__ + "img/agent.ef16fb21.svg";